import { render, staticRenderFns } from "./MagazzinoArticoliFornitoriModalEditComponent.vue?vue&type=template&id=5d638fcc"
import script from "./MagazzinoArticoliFornitoriModalEditComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliFornitoriModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports